import { Component, HostListener, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import { CategoryService } from '../../category.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import * as data from '../../content.json';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  public toggleMenu = false;
  public toggleSubMenu = false;
  // public subCategory;
  private subCategoryActiveted = '';
  public categories = [];

  public categoryActivated = '';
  public currentPage = '';

  element: HTMLElement | null;

  public lang = '';
  public content = {};

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private categoryService: CategoryService,
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };
  }

  ngOnInit(): void {

    // Get a reference to your element
    this.element = document.getElementById('yourElement');

    // Initial styles
    // this.updateStyles();

    this.setLang();



    this.currentPage = this.router.url.replace(/\?lang=(en|pt-br)/, '');
    console.log(this.currentPage);

    this.categoryActivated = this.activatedRoute.snapshot.paramMap.get('category');



    this.toggleMenu = (this.activatedRoute.snapshot.queryParams.menu == 'true')?true:false;
    // this.subCategory = this.activatedRoute.snapshot.queryParams.category;
    if(this.toggleMenu){
      this.toggleSubMenu = true;
      this.subCategoryActiveted = this.activatedRoute.snapshot.paramMap.get('subcategory');
    }
    this.loadCategories();
  }


  async loadCategories() {
    this.categories = await this.categoryService.getAll();
    // console.log(categories);
    // return await this.categoryService.getAll();
  }

  showMenu(){
    // this.toggleMenu = !this.toggleMenu;
    if(this.toggleMenu){
      this.redirect('/');
    }
    this.toggleMenu = true;
    // if(!this.toggleMenu)
    //   this.toggleSubMenu = false;
    // this.subCategory = null;
  }

  showSubMenu(category){
    this.toggleSubMenu = true;
    // this.subCategory = category
    this.categoryActivated = category
  }

  public trackItem (index, item) {
    return item.trackId;
  }

  redirect(rota){
    rota = (this.lang == 'en') ? rota + '?lang=en' : rota;
    this.router.navigateByUrl(rota);
  }

  setLang(){
    this.lang = (this.activatedRoute.snapshot.queryParams['lang'] == undefined) ? 'pt-br' : this.activatedRoute.snapshot.queryParams['lang'];

    if(this.lang == 'en'){
      this.content = data['en']['menu'];
    }else{
      this.content = data['pt-br']['menu'];
    }
  }

  changeLang() {
    // Navigate to the same route with a different lang parameter
    this.lang = this.activatedRoute.snapshot.queryParams['lang'];

    var url = this.router.url.replace(/(\?|\&)lang=(en|pt-br)/, '');

    const key = this.activatedRoute.snapshot.queryParams['key'];
    if(key){
      url = this.router.url.replace(/(\?|\&)key=\d+/g, '');

      this.router.navigate([url], { queryParams: { lang: this.lang, key: key } });

      if(this.lang == 'en'){
        this.router.navigate([url], { queryParams: { key: key, lang: 'pt-br' } });
      }else{
         this.router.navigate([url], { queryParams: { key: key, lang:'en' } });
      }
      

    }else{
      if(this.lang == 'en'){
        this.router.navigate([url], { queryParams: { lang: 'pt-br' } });
      }else{
         this.router.navigate([url], { queryParams: { lang:'en' } });
      }
    }

  }


  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event) {
    this.updateStyles();
  }

  updateStyles() {
    if (this.element) {
      var currentTime = new Date();
      var currentScrollPosition = window.scrollY;

      // Replace the following conditions with your specific requirements
      if (currentTime.getHours() >= 12 && currentScrollPosition >= 2000) {
        this.element.style.position = 'block';
        this.element.style.display = 'block';
        // Add any other styles you want for the block display
      } else {
        this.element.style.position = 'block';
        this.element.style.display = 'block';
        // Add any other styles you want for the fixed display
      }
    }
  }




  isDropdownOpen = false;

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

}



